<form method="#" action="#">
  <div class="card card-login">
    <div class="card-content">
      <div class="text-center login-header">
        <img src="assets/img/placeholder.jpg" class="img-circle profile-photo" alt="User Name" title="User Name"/>

        <div class="dropdown">
          <h3 class="dropdown-toggle" data-toggle="dropdown"><a href="#">Login name <b class="caret"></b></a></h3>
          <ul class="dropdown-menu dropdown-menu-right">
            <li class="dropdown-header"><h5>Login as another user</h5></li>
            <li class="divider"></li>
            <li><a href="#">Login name 1</a></li>
            <li><a href="#">Login name 2</a></li>
          </ul>
        </div>
      </div>

      <div class="input-group">
          <span class="input-group-addon">
            <i class="material-icons">lock</i>
          </span>
          <div class="form-group label-floating is-empty">
            <label class="control-label">Password</label>
            <input type="text" class="form-control">
          </div>
      </div>

      <a href="able_home.html" class="btn btn-block btn-able">Login</a>
    </div>

    <div class="footer text-center">
      <p class="small"><a href="able_forgot_password.html">Forgot password or username?</a></p>
      <p class="small"><a href="able_login.html"><i class="material-icons">account_box</i> Sign in with a different account</a></p>
    </div>

  </div>
</form>
